///////////////////////////////////////////////////////////////////////////////
//版权所有（C）2002-2022，成都梦想凯德科技有限公司。
//本软件代码及其文档和相关资料归成都梦想凯德科技有限公司,应用包含本软件的程序必须包括以下版权声明
//此应用程序应与成都梦想凯德科技有限公司达成协议，使用本软件、其文档或相关材料
//https://www.mxdraw.com/
///////////////////////////////////////////////////////////////////////////////

import { MxFun } from "mxdraw";
import {
    McDbCustomEntity, McGePoint3d, IMcDbDwgFiler, McGePoint3dArray, MxCADWorldDraw,
    McDbPolyline, MxCADUiPrPoint, MxCpp, McDbCircle, McDb, McDbCurve, McDbText, MxCADUiPrString
} from "mxcad";

class McDbRectBoxLeadComment extends McDbCustomEntity {
    /** 云线角点1 */
    private pt1: McGePoint3d;
    /** 云线角点2 */
    private pt2: McGePoint3d;
    /** 多云线框角点数组 */
    private cornerArray: McGePoint3d[]
    /** 审图标注点 */
    private pt3: McGePoint3d;
    /** 审图标注内容 */
    private _text: string = "";
    /** 字高 */
    private _textsize: number = 20;
    /** 云线半圆弧半径 */
    private _radius: number = 15;

    constructor(imp?: any) {
        super(imp);
    }
    public create(imp: any) {
        return new McDbRectBoxLeadComment(imp)
    }
    public getTypeName(): string {
        return "McDbRectBoxLeadComment";
    }

    //设置或获取文本值
    public set text(val: string) {
        this._text = val;
    }
    public get text(): string {
        return this._text;
    }
    //设置或获取文本大小
    public set textsize(val: number) {
        this._textsize = val;
    }
    public get textsize(): number {
        return this._textsize;
    }
    //设置或获取云线半圆弧半径
    public set radius(val: number) {
        this._radius = val;
    }
    public get radius(): number {
        return this._radius;
    }

    public dwgInFields(filter: IMcDbDwgFiler): boolean {
        this.pt1 = filter.readPoint("pt1").val;
        this.pt2 = filter.readPoint("pt2").val;
        this.pt3 = filter.readPoint("pt3").val;
        this._text = filter.readString("text").val;
        this._textsize = filter.readDouble("textsize").val;
        return true;
    }
    public dwgOutFields(filter: IMcDbDwgFiler): boolean {
        filter.writePoint("pt1", this.pt1);
        filter.writePoint("pt2", this.pt2);
        filter.writePoint("pt3", this.pt3);
        filter.writeString("text", this._text);
        filter.writeDouble("textsize", this._textsize);
        return true;
    }
    public moveGripPointsAt(iIndex: number, dXOffset: number, dYOffset: number, dZOffset: number) {
        this.assertWrite();
        if (iIndex === 0) {
            this.pt1.x += dXOffset;
            this.pt1.y += dYOffset;
            this.pt1.z += dZOffset;
        } else if (iIndex === 1) {
            this.pt2.x += dXOffset;
            this.pt2.y += dYOffset;
            this.pt2.z += dZOffset;
        } else if (iIndex === 2) {
            this.pt3.x += dXOffset;
            this.pt3.y += dYOffset;
            this.pt3.z += dZOffset;
        }
    };
    public getGripPoints(): McGePoint3dArray {
        let ret = new McGePoint3dArray();
        ret.append(this.pt1);
        ret.append(this.pt2);
        ret.append(this.pt3);
        return ret;
    };
    public worldDraw(draw: MxCADWorldDraw): void {
        const radius = this._radius;

        // 根据弧线半径，重新计算云线角点
        if (this.pt1.x < this.pt2.x) {
            const dist = this.pt2.x - this.pt1.x;
            const num = parseInt((dist / (radius * 2)).toString());
            this.pt2.x = this.pt1.x + radius * 2 * num;
        } else {
            const dist = this.pt1.x - this.pt2.x;
            const num = parseInt((dist / (radius * 2)).toString());
            this.pt1.x = this.pt2.x + radius * 2 * num;
        }

        if (this.pt1.y < this.pt2.y) {
            const dist = this.pt2.y - this.pt1.y;
            const num = parseInt((dist / (radius * 2)).toString());
            this.pt2.y = this.pt1.y + radius * 2 * num;
        } else {
            const dist = this.pt1.y - this.pt2.y;
            const num = parseInt((dist / (radius * 2)).toString());
            this.pt1.y = this.pt2.y + radius * 2 * num;
        }
        // 审图框线
        const pl = new McDbPolyline();
        pl.isClosed = true;
        pl.addVertexAt(this.pt1);
        pl.addVertexAt(new McGePoint3d(this.pt2.x, this.pt1.y));
        pl.addVertexAt(this.pt2);
        pl.addVertexAt(new McGePoint3d(this.pt1.x, this.pt2.y));

        // 根据审图框线与半径获取出云线所有圆弧的圆心
        const length = pl.getLength().val;
        let num = length / radius;
        // 获取圆心
        const circleCenterArr: McGePoint3d[] = [];
        for (let i = 1; i <= num; i++) {
            const pt = pl.getPointAtDist(radius * i).val;
            circleCenterArr.push(pt)
        }

        // 根据圆心与圆弧半径绘制云线圆弧
        circleCenterArr.forEach((center, index) => {
            const circle = new McDbCircle(center.x, center.y, center.z, radius);
            if (index % 2 === 0) {
                const ptArr: McGePoint3d[] = []
                circle.IntersectWith(pl, McDb.Intersect.kOnBothOperands).forEach(pt => {
                    ptArr.push(pt)
                });
                circle.splitCurves(ptArr).forEach(e => {
                    const pt = (e as McDbCurve).getPointAtDist((e as McDbCurve).getLength().val / 2).val;
                    if (pt.x < Math.min(...[this.pt1.x, this.pt2.x]) || pt.x > Math.max(...[this.pt1.x, this.pt2.x])) {
                        draw.drawEntity(e as McDbCurve);
                    }
                    if (pt.y < Math.min(...[this.pt1.y, this.pt2.y]) || pt.y > Math.max(...[this.pt1.y, this.pt2.y])) {
                        draw.drawEntity(e as McDbCurve);
                    }
                })
            }
        });
        /**
         * 绘制标注
         */
        const distanceArr: number[] = []
        for (let i = 0; i < pl.numVerts(); i++) {
            const dist = pl.getPointAt(i).val.distanceTo(this.pt3);
            distanceArr.push(dist);
        };
        const index = distanceArr.indexOf(Math.min(...distanceArr));
        const pt = pl.getPointAt(index).val;

        const pl_text = new McDbPolyline();
        pl_text.addVertexAt(pt);
        pl_text.addVertexAt(this.pt3);
        if (this._text) {
            const text = new McDbText();
            text.textString = this._text;
            text.position = text.alignmentPoint = this.pt3;
            text.height = 20;
            draw.drawEntity(text);
            const { minPt, maxPt, ret } = text.getBoundingBox();
            if (!ret) return;

            const textWidth = maxPt.x - minPt.x;
            pl_text.addVertexAt(new McGePoint3d(this.pt3.x + textWidth, this.pt3.y));
            draw.drawEntity(pl_text);
        } else {
            draw.drawEntity(pl_text);
        }

    }
    public setPoint1(pt1: McGePoint3d) {
        this.assertWrite();
        this.pt1 = pt1.clone();
    }
    public setPoint2(pt2: McGePoint3d) {
        this.assertWrite();
        this.pt2 = pt2.clone();
    }
    public setPoint3(pt3: McGePoint3d) {
        this.assertWrite();
        this.pt3 = pt3.clone();
    }
    public getPoint1() {
        return this.pt1;
    }
    public getPoint2() {
        return this.pt2;
    }
    public getPoint3() {
        return this.pt3;
    }
}

async function Mx_Approval() {

    const getPt1 = new MxCADUiPrPoint();
    getPt1.setMessage("指定云线框起始点");
    const pt1 = await getPt1.go();
    if (!pt1) return;
    const getPt2 = new MxCADUiPrPoint();
    getPt2.setMessage("指定云线框终止点");
    let id;
    getPt2.setUserDraw((pt, pw) => {
        if (id) id.erase();
        const rectBoxLeadComment = new McDbRectBoxLeadComment();
        rectBoxLeadComment.setPoint1(pt1);
        rectBoxLeadComment.setPoint2(pt);
        rectBoxLeadComment.setPoint3(pt);
        id = MxCpp.getCurrentMxCAD().drawEntity(rectBoxLeadComment)
    })
    const pt2 = await getPt2.go();
    if (!pt2) {id.erase(); return };

    const getContent = new MxCADUiPrString();
    getContent.setMessage("请输入审批意见");
    let content = await getContent.go();

    const getPt3 = new MxCADUiPrPoint();
    getPt3.setMessage("指定审图标注点");
    getPt3.setUserDraw((pt, pw) => {
        if (id) id.erase();
        const rectBoxLeadComment = new McDbRectBoxLeadComment();
        rectBoxLeadComment.setPoint1(pt1);
        rectBoxLeadComment.setPoint2(pt2);
        rectBoxLeadComment.setPoint3(pt);
        rectBoxLeadComment.text = content;
        id = MxCpp.getCurrentMxCAD().drawEntity(rectBoxLeadComment)
    })
    const pt3 = await getPt3.go();
    if (!pt3) id.erase();
}

export function init() {
    new McDbRectBoxLeadComment().rxInit()
    MxFun.addCommand("Mx_Approval", Mx_Approval);
}